import logoInstagram from 'components/images/logos/logo_instagram.svg'
import useInstagramSetup from './useInstagramSetup'
import ChannelCard from "../../Utilities/ChannelCard";

export default function InstagramProvider() {
	const { initiateInstagramSetup } = useInstagramSetup()
	return (
		<ChannelCard
			icon={logoInstagram}
			label={'Instagram'}
			description={'Get social support and moderation on your Instagram Ads, Mentions, Posts, and DMs. (Reels are not currently supported)'}
			onClick={initiateInstagramSetup}
		/>
	)
}